import { getColourPalettes } from 'apiCalls/apiCalls';
import { Modal } from 'components/Modal';
import { DeleteColourPalettes } from './DeleteColourPalettes';

export const DeleteColourPalettesModal = ({ isOpen, setIsOpen, setColourPalettes }) => {
    const handleClose = async () => {
        try {
            const colourPalettes = await getColourPalettes();
            setColourPalettes({ loading: false, result: colourPalettes });
            setIsOpen(false);
        } catch (error) {
            setColourPalettes({ loading: false, error: { message: 'Network Error' } });
            setIsOpen(false);
        }
    };

    return (
        <Modal open={isOpen} onClose={handleClose} title="Delete Colour Palettes">
            <DeleteColourPalettes />
        </Modal>
    );
};
